import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { Form } from '@ant-design/compatible';
import { maskFormat } from '../../../services/MaskService'

const onChange = (event, mask) => {
  if (mask) {
    return maskFormat(mask, event)
  }
}

const InputText = ({ name, rules, initialValue, placeholder, prefix, form, type, formItemStyle, mask, disabled, autoComplete = 'off', label }) => {
  return (
    <Form.Item label={label} style={formItemStyle}>
      {form.getFieldDecorator(name, {
        rules,
        initialValue: initialValue
      })(
        <Input disabled={disabled} autoComplete={autoComplete} onKeyUp={event => onChange(event, mask)} prefix={prefix} placeholder={placeholder} type={type} />
      )}
    </Form.Item>
  )
}

InputText.propTypes = {
  form: PropTypes.object.isRequired,
  rules: PropTypes.array,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  prefix: PropTypes.element,
  formItemStyle: PropTypes.object,
  mask: PropTypes.string
}

InputText.defaultProps = {
  type: "text"
}

export default InputText
